@if ( data.deploymentClass === DeploymentClass.D || isViewAllowed) {
<div class="flex items-center justify-between">
  <div class="flex items-center">
    <mat-icon svgIcon="checklist" class="mr-8"></mat-icon>
    @if(isViewAllowed){
    <div class="mat-subtitle-2 mb-0 fs-24 fw-600" [ngClass]="{'active fw-600': sanityTest}">{{'TEST_RESULTS.SANITY_TEST'
      | transloco}}
      <span>({{searchTerm?.length > 0 && searchedResult ? searchedResult.length || 0 :(sanityTestResults?.length ||
        0)}})</span>
    </div>
    }
    <div class="ml-16 search-test">
      <app-search-filter [ngClass]="{'disabled': !availableConfigLoaded || sanityTestResults?.length === 0}" class="mt-20 ml-20"
        placeholder="SEARCH.SEARCH" (changed)="search($event)"></app-search-filter>
    </div>
    <span class="vertical-dash ml-12"></span>
    <button [ngClass]="{'disabled': !availableConfigLoaded || sanityTestResults?.length === 0}"
      class="flex justify-center items-center context-menu-icon-filter height menu-btn pr-8 pl-8 pt-6 pb-6 ml-12 filter"
      (click)="filterColumns()">
      <mat-icon svgIcon="filter_alt" class="mr-4"></mat-icon>
      <span class="fw-500 filters">{{'TENANT_LIST.FILTERS' | transloco}}</span>
    </button>
  </div>
  @if (sanityTest && isExecuteAllowed) {
  <div class="flex flex-row gap-3 create-runbook">
    <button class="flex accent h-32 mt-16 mr-8"
      [ngClass]="{'disable': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || isSanityTestInprogress && availableConfigLoaded || (data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES) || (showLoader)) : isSanityTestInprogress && availableConfigLoaded || (data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES) || (showLoader)}"
      matTooltipClass="above" matTooltipPosition="above"
      [matTooltip]="(isSanityTestInprogress || (!EXCECUTETEST_ENABLE_STATES.includes(data?.status) && !INSTANCE_DEPLOYING_STATES.includes(data?.status))) ? ('TEST_RESULTS.EF_TEST_TOOLTIP' | transloco) : null"
      (click)="(isSanityTestInprogress || !EXCECUTETEST_ENABLE_STATES.includes(data?.status)) ? '' : excecuteSanityTest()">
      {{'TEST_RESULTS.EXCECUTE_TEST' | transloco}}
    </button>
    <div class="flex items-center border-left mr-4"></div>
    <div class="refresh-circle rounded-full w-32 h-32 flex items-center justify-center cursor-pointer"
      (click)="refreshClick()">
      <mat-icon svgIcon="refresh" class="icons transition-transform duration-700"
        [ngClass]="{ 'animate-spin': isRefreshing }"></mat-icon>
    </div>
    @if(sanityTestResults?.length > 0){
    <app-environment-paginator [length]="searchedResult?.length" [pageIndex]="pageIndex" [pageSize]="paginationSize"
      (page)="onPageChange($event)" class="env-paginator"></app-environment-paginator>
    }
  </div>
  }
</div>
@if(selectedStatus?.length > 0){
<div class="flex flex-row items-center mt-8 ml-8">
  @if(selectedStatus?.length > 0){
  <span class="pr-8 fs-16">{{ 'TOOLBAR.STATUS' | transloco }}</span>
  <div class="mr-4 pt-8 pb-4 filtered-items flex items-center fs-16 fw-500">
    @for (status of selectedStatus; track status) {
    <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-16">
      {{getStatusLabel(status) | titlecase}}
      <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="cancelStatusFilter(status)"></mat-icon>
    </span>
    }
  </div>
  }
  <div class="flex flex-row items-center">
    @if(selectedStatus?.length > 0){
    <span class="flex justify-center items-center mat-subtitle-2 mb-0 fw-500 cursor-pointer warn-solid-fg"
      (click)="resetSanityTestFilter()">
      {{ 'BUTTONS.CLEAR_ALL' | transloco }}
    </span>
    }
  </div>
</div>
}
<mat-divider class="neutral-2 mt-12 mb-12 ml-4 mr-4"></mat-divider>
@if(showLoader){
<div class="loader-section">
  <div class="runbook-group loader-header flex flex-col p-16">
    <div class="flex flex-row">
      @for (tableColumn of displayColumns; track tableColumn?.key) {
      <div class="loader-style">
        <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
      </div>
      }
    </div>
  </div>

  @for (item of [1, 2, 3]; track $index) {
  <div class="w-100-percent">
    <div class="runbook-group flex flex-col p-16">
      <div class="flex flex-row">
        @for (tableColumn of displayColumns; track tableColumn?.key) {
        <div class="loader-style">
          <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
        </div>
        }
      </div>
    </div>
  </div>
  }
</div>
}
@if (sanityTest) {
@if ((sanityTestResults?.length > 0 || sanityTestData?.length > 0 )  && availableConfigLoaded && !showLoader) {
<div class="flex flex-col border-radius mb-16 mt-8">
  <app-environment-table class="runbook-table" [displayColumns]="displayColumns" [instance]="instance"
    [initialDataSource]="sanityTestResults" [dataSourceLength]="sanityTest"
    [initialCreate]="sanityTestResults?.length === 0 && sanityTestData?.length === 0" (sorted)="resetPaginator()" (pageChanged)="onPageChange($event)"
    (searchedResults)="searchedItems($event)" [searchTerm]="searchTerm"
    pageName="environmentSanityTest"></app-environment-table>
</div>
} @else if(availableConfigLoaded && sanityTestResults?.length === 0 && sanityTestData?.length === 0 && !showLoader) {
<div class="flex flex-col">
  <div class="flex flex-col empty-panel ml-10 mr-16 mt-16">
    <div class="empty-data flex flex-col items-center mt-32 ">
      <img class="w-106" alt="efTest not found" src="/assets/images/service_not_found.png">
      <div class="flex mt-6 ">{{'SANITY_TEST.NO_SANITY_CREATED' | transloco }}</div>
    </div>
  </div>
</div>
}
}
} @else {
<div class="flex flex-col items-center justify-center pt-8 pb-10 mt-30 fs-16">
  <img src="/assets/images/feature_not_available.png">
  <div class="mt-10 feature-not-avaliable">{{'FEATURE.FEATURE_NOT_AVAILABLE' | transloco}}</div>
</div>
}